export class BrowserMediaStreamTransport {
    mediaDevices;
    stream = null;
    speakerEnabled = true;
    constructor(mediaDevices = navigator.mediaDevices) {
        this.mediaDevices = mediaDevices;
    }
    async connect(_grant, events) {
        await this.disconnect();
        try {
            this.stream = await this.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }, video: false });
            for (const track of this.stream.getAudioTracks())
                track.enabled = false;
            events.onNetworkQualityChanged("excellent");
        }
        catch (error) {
            const normalized = error instanceof Error ? error : new Error("Microphone permission denied");
            events.onPermissionError(normalized);
            throw normalized;
        }
    }
    setMicrophoneEnabled(enabled) {
        for (const track of this.stream?.getAudioTracks() ?? [])
            track.enabled = enabled;
        return Promise.resolve();
    }
    setSpeakerEnabled(enabled) {
        this.speakerEnabled = enabled;
        return Promise.resolve();
    }
    disconnect() {
        if (this.stream) {
            for (const track of this.stream.getTracks())
                track.stop();
            this.stream = null;
        }
        return Promise.resolve();
    }
    get localStream() {
        return this.stream;
    }
    get isSpeakerEnabled() {
        return this.speakerEnabled;
    }
}
//# sourceMappingURL=browser-media-stream-transport.js.map